import { Button, Col, Row, Space, Typography } from "antd";
import VesselsView from "../components/VesselsView";
import { useState } from "react";
import { VesselForm } from "../components/VesselFormDialog.default";
import { Guid } from "guid-typescript";
import VesselFormDialog from "../components/VesselFormDialog";
import { CompanyVessel } from "../repository/data.default";

function CompanyVesselsPage() {
  const [vesselInputMode, setVesselInputMode] = useState<
    "add" | "update" | "delete"
  >("add");
  const [vesselInputOpen, setVesselInputOpen] = useState(false);
  const [vesselInputValues, setVesselInputValues] = useState<
    VesselForm | undefined
  >(undefined);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());

  function onVesselInputOpen(
    mode: "add" | "update" | "delete",
    values?: CompanyVessel,
  ): void {
    setVesselInputMode(mode);
    setVesselInputOpen(true);
    setVesselInputValues(
      values
        ? {
            uid: values.uid,
            rowVersion: values.rowVersion,
            name: values.name,
            code: values.code,
            type: {
              display: values.typeName,
              value: values.typeUid,
            },
          }
        : undefined,
    );
  }

  function onVesselInputFinish(): void {
    setVesselInputOpen(false);
    setTriggerView(Guid.create().toString());
  }

  function onVesselInputClose(): void {
    setVesselInputOpen(false);
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Vessels
        </Typography.Title>
        <Space className="flex flex-row">
          <Button type="primary" onClick={() => onVesselInputOpen("add")}>
            Add Vessel
          </Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <VesselsView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onVesselInputOpen(key as any, record)
          }
        />
      </Col>
      <VesselFormDialog
        key={vesselInputMode}
        mode={vesselInputMode}
        open={vesselInputOpen}
        initialValues={vesselInputValues}
        onFinish={onVesselInputFinish}
        onCancel={onVesselInputClose}
      />
    </Col>
  );
}

export default CompanyVesselsPage;
